module.exports = __webpack_public_path__ + "img/persistence-small-dark.d57c55ef.svg";